import { CommonModule } from '@angular/common';
import { Component, Input, WritableSignal, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AssessmentsService } from '../../services/assessments.service';
import { Mwt6Data, SingleNumberDataSet, initDataMWT6 } from '../../services/model';
import { getDateIsoString, getDateIsoStringPlus1Minute } from '../../services/util.functions';
import { AssessmentBaseComponent } from '../assessment-base/assessment-base.component';
import { SingleNumberTableInputComponent } from '../single-number-table-input/single-number-table-input.component';

@Component({
  selector: 'app-mwt6',
  standalone: true,
  imports: [
    SingleNumberTableInputComponent,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatChipsModule,
    MatSelectModule,
    MatTableModule,
    RouterModule,
    MatTooltipModule,
    MatIconModule,
  ],
  templateUrl: './mwt6.component.html',
  styleUrl: './mwt6.component.scss',
})
export class Mwt6Component extends AssessmentBaseComponent {
  @Input() assessmentId: string | undefined;
  protected readonly anleitung =
    'MWT6 stellt ein einfaches Testverfahren dar, um bei geriatrischen und neurologischen Patienten die Mobilität zu beurteilen.\n\n' +
    '\n\n';
  private assessmentService: AssessmentsService = inject(AssessmentsService);
  private fb: FormBuilder = inject(FormBuilder);
  assessmentData: WritableSignal<Mwt6Data | undefined> = signal<Mwt6Data | undefined>(undefined);
  assessmentDataNew: Mwt6Data = JSON.parse(JSON.stringify(initDataMWT6));

  form: FormGroup = this.fb.group({
    assessmentTime: [getDateIsoStringPlus1Minute(), Validators.required],
  });

  onData(data: { data: Array<SingleNumberDataSet>; note: string }) {
    this.assessmentDataNew.mwt6.data = data.data;
    this.assessmentDataNew.mwt6.note = data.note;
  }

  ngOnInit(): void {
    if (this.assessmentId) {
      this.assessmentService.getAssessment(this.assessmentId).then(data => {
        this.assessmentData.set(data.data as Mwt6Data);
        const date = getDateIsoString(new Date(data.dateIso));
        this.form.controls['assessmentTime'].patchValue(date);
        this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
      });
    } else {
      this.assessmentData.set(initDataMWT6);
      this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
    }
  }
  onSave() {
    if (this.assessmentId) {
      this.assessmentService
        .updateAssessment(this.assessmentId, {
          type: 'MWT6',
          dateIso: this.form.controls['assessmentTime'].value,
          data: this.assessmentDataNew,
        })
        .then(res => {
          this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
        });
    } else {
      this.assessmentService
        .createAssessment({
          type: 'MWT6',
          dateIso: this.form.controls['assessmentTime'].value,
          data: this.assessmentDataNew,
        })
        .then(res => {
          this.router.navigate(['../../reports/assessments'], { relativeTo: this.route });
        });
    }
  }

  onNavigateBack() {
    if (this.assessmentId) {
      this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
    } else {
      // this.router.navigate(['../../reports/assessments'], { relativeTo: this.route });
      this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
    }
  }
}
